
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import moment from 'moment';
    import { SweetAlertResult } from 'sweetalert2';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import { confirmSwal } from '@/helper/swals';
    import Karteieintrag from '@/types/Karteieintrag';
    import Text from '@/types/Text';
    import { ValidationRules } from '@/store/types';
    import { VForm } from '@/types/Components';
    import Patient from '@/types/Patient';
    import { LoadTextePayload } from '@/store/texte';
    import { LoadPersonenPayload } from '@/store/personen';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules', 'formatDate', 'parseDate']),
            ...mapState('session', ['arzt']),
            ...mapState('patient', ['patientData', 'loaders']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapState('texte', ['texte']),
            ...mapState('texte', { texteLoaders: 'loaders' }),
            ...mapGetters('personen', ['getPersonen']),
            ...mapState('personen', { personenLoaders: 'loaders' }),
        },
        methods: {
            ...mapMutations('session', ['setSelectedArzt']),
            ...mapActions('patient', ['createText', 'deleteText', 'downloadTextDatei']),
            ...mapActions('texte', ['loadTexte']),
            ...mapActions('personen', ['loadPersonen']),
        },
    })
    export default class TextDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() value!: Karteieintrag;

        public $refs!: {
            form: VForm;
        };

        public rules!: ValidationRules;
        public parseDate!: (input: string | null) => string | null;
        public formatDate!: (input: string | null) => string | null;
        public patientData!: Patient;
        public impfstelle_id!: number;
        public arzt!: number | null;
        public loadTexte!: (payload?: LoadTextePayload) => void;
        public loadPersonen!: (payload?: LoadPersonenPayload) => void;
        public texte!: Text[];
        public createText!: (payload: { text: Karteieintrag; files: File | File[] | null }) => void;
        public deleteText!: () => void;

        public text = new Karteieintrag();
        public code = new Text();
        public files: File | File[] | null = null;

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get isNew(): boolean {
            return this.text.patimpfung_id === null;
        }

        public get isReadonly(): boolean {
            return false;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (!visible) return;

            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }

            this.text = new Karteieintrag(this.value);
            this.code = new Text();
            this.files = null;

            if (this.isNew) {
                this.text.patnr = this.patientData.patnr;
                this.text.impfstelle_id = this.impfstelle_id;

                if (this.arzt) {
                    this.text.person_id_durchf = this.arzt;
                }

                this.loadTexte();

                this.text.impfdatum = moment().format('YYYY-MM-DD');
                this.impfdatumErrorMessages = [];
                this.impfdatumFormatted = this.formatDate(this.text.impfdatum);
            }

            this.loadPersonen({ filter: { impfstelle_id: this.text.impfstelle_id as number } });
        }

        @Watch('code')
        public onChangeTextCode({ text_id }: Text): void {
            if (!this.text.text) {
                this.text.text = this.texte.find((text: Text) => text.text_id === text_id)?.text ?? null;
            }
        }

        public onClickSave(): void {
            if (!this.$refs.form.validate() || this.impfdatumErrorMessages.length > 0) {
                return;
            }

            this.createText({ text: this.text, files: this.files });
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Text endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteText();
                    }
                });
        }

        public impfdatumMenu = false;
        public impfdatumFormatted: string | null = null;
        public impfdatumErrorMessages: string[] = [];

        @Watch('text.impfdatum')
        public onChangeImpfdatum(date: string | null): void {
            this.impfdatumFormatted = this.formatDate(this.text.impfdatum);

            if (date !== null && this.isNew) {
                this.impfdatumErrorMessages = [];

                for (const rule of [this.rules.required, this.rules.validDate]) {
                    const valid = rule(this.text.impfdatum);
                    if (valid !== true) {
                        this.impfdatumErrorMessages.push(valid as string);
                    }
                }

                if (this.text.impfdatum && (this.text.impfdatum > moment().format('YYYY-MM-DD'))) {
                    this.impfdatumErrorMessages.push('Datum darf nicht in der Zukunft sein.');
                }
            }
        }
    }
